import { Flex, HStack, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { CheckIcon, DocumentTextIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

import { IdentityType } from '@blockpulse3/graphql/hooks';

import { useSPVForm } from '../../../provider';

type Props = unknown;

/**
 * SummaryDocuments.
 * Summary documents for the SPV funnel.
 *
 * @returns {JSX.Element}
 */
export function SummaryDocuments(): JSX.Element {
  const i18nSummaryDocuments = useTranslations('SPVSummaryDocuments');

  const { companyDraftContent } = useSPVForm();

  return (
    <Stack spacing="4">
      <Stack spacing="4">
        <Text fontSize="xl" fontWeight="bold">
          {i18nSummaryDocuments('DocumentTitle')}
        </Text>
        <SimpleGrid gap="4" minChildWidth="300px">
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentStatus')}
            </Text>
          </HStack>
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentAddress')}
            </Text>
          </HStack>
          {companyDraftContent.representatives[0].type === IdentityType.INDIVIDUAL && (
            <HStack>
              <Flex
                alignItems="center"
                bg="gray.50"
                borderRadius="full"
                boxSize="32px"
                justifyContent="center"
              >
                <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
              </Flex>
              <Text color="gray.600" fontWeight="medium">
                {i18nSummaryDocuments('DocumentDNC')}
              </Text>
            </HStack>
          )}
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentSubscriber')}
            </Text>
          </HStack>
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentDBE')}
            </Text>
          </HStack>
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentFormalites')}
            </Text>
          </HStack>
          <HStack>
            <Flex
              alignItems="center"
              bg="gray.50"
              borderRadius="full"
              boxSize="32px"
              justifyContent="center"
            >
              <Icon as={DocumentTextIcon} boxSize="24px" color="gray.500" />
            </Flex>
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('DocumentFormM0')}
            </Text>
          </HStack>
        </SimpleGrid>
      </Stack>
      <Stack spacing="4">
        <Text fontSize="xl" fontWeight="bold">
          {i18nSummaryDocuments('ServicesTitle')}
        </Text>
        <SimpleGrid gap="4" minChildWidth="300px">
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service1')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service2')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service3')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service4')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service5')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service6')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service7')}
            </Text>
          </HStack>
          <HStack>
            <Icon as={CheckIcon} boxSize="24px" color="green.500" />
            <Text color="gray.600" fontWeight="medium">
              {i18nSummaryDocuments('Service8')}
            </Text>
          </HStack>
        </SimpleGrid>
      </Stack>
    </Stack>
  );
}

export type SummaryDocumentsProps = Props;
